/**
 * GENERATED_ASSET — batch005 domestic/window construction facade (reviewed `domestic-window/source/index.ts`).
 *
 * Pure, browser-safe construction for the canonical recipes hush.cushion.patched.v1, hush.cups.pair.v1 and
 * hush.tide_window.quiet.v1. Output is source-space art (origin = painted bottom-center at 0,0); projection into
 * a template frame, palette mapping and cache identity belong to the game-side adapter
 * (`src/game/effects/nature/props/hushDomestic/`). The workshop's offline `configureConsumer` and owner import hook
 * are harness-only and deliberately not ported.
 */
import { DomesticContext } from './context';
import { buildCushion } from './cushion';
import { buildCups } from './cups';
import { buildWindow } from './window';
import type { DraftArtifact } from './types';
export { validateRecipe } from './validate';
export { validateTokens } from './kit';
export { HUSH_DOMESTIC_TOKENS } from './tokens';
export { HUSH_DOMESTIC_RECIPES } from './recipes';
export { REVISION as HUSH_DOMESTIC_GENERATOR_REVISION } from './types';
export type { DomesticRecipe, CushionRecipe, CupPairRecipe, TideWindowRecipe, DraftArtifact, DraftLayer, Tokens,
  ResolvedPalette, PaletteRole, PaletteId, VisualBounds, VisualAnchor, Point2, ProtectedVisualRegion } from './types';

export function buildDomestic(recipe:unknown,tokens:unknown,scope='domestic_isolated'):DraftArtifact{
  const c=new DomesticContext(recipe,tokens,scope);switch(c.recipe.generatorId){case'hush.cushion.v1':return buildCushion(c);case'hush.cups.v1':return buildCups(c);case'hush.tide_window.v1':return buildWindow(c);}
}
